<template>
  <div class="s-container">
    <h2>切換院所 / 院區</h2>
    <p>請選擇您希望查看的院區，點選後系統將會切換圖文選單，並呈現該院區相關服務內容：</p>
    <b-overlay :show="isLoadingInstitutions || isUpdatingSelectedInstitution">
      <div class="institution-list">
        <div
          v-for="institution in availableInstitutions"
          :key="institution.display_name"
          :class="['institution-card', { 'institution-card--selected': selectedInstitution === institution }]"
          @click="selectedInstitution = institution"
        >
          <div class="institution-card__name">{{ institution.display_name }}</div>
          <div class="institution-card__memo">{{ institution.display_memo }}</div>
        </div>
      </div>
    </b-overlay>
    <p class="notice-text">
      註：當您實體就診或至官網掃描 QR code 後，即可查看該院所之服務。
      切換至新院區後，原院所之客服同仁將無法再看見與回覆您的訊息。
    </p>
    <div class="footer-nav">
      <button class="btn btn-secondary" @click="handleBack">＜ 返回</button>
      <button
        v-if="availableInstitutions.length > 1"
        class="btn btn-primary"
        :disabled="!selectedInstitution || isUpdatingSelectedInstitution"
        @click="submit"
      >確認切換 ＞</button>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import cresclabMenuApi from "@/apis/liff/v2/cresclab-menu"
import stepController from "@/mixins/web/tongxin/stepController"

export default {
  data() {
    return {
      availableInstitutions: [],
      isLoadingInstitutions: false,
      isUpdatingSelectedInstitution: false,
      selectedInstitution: null,
    }
  },
  async mounted() {
    this.isLoadingInstitutions = true
    const institutions = _.get(await cresclabMenuApi.listAvailableInstitutions(), "data.data", [])
    this.availableInstitutions = Array.isArray(institutions)
      ? institutions
      : Object.values(institutions || {})
    this.isLoadingInstitutions = false
  },
  methods: {
    handleBack() {
      this.$router.go(-1)
    },
    async submit() {
      this.isUpdatingSelectedInstitution = true
      try {
        await cresclabMenuApi.updateSelectedInstitution(this.selectedInstitution.tag_name)
        await this.$swal("切換院區完成", "", "success")
        stepController.methods.goToLineOfficialAccount.call(this)
      } catch (error) {
        this.$swal("院所更新失敗", "", "error")
      }
      this.isUpdatingSelectedInstitution = false
    },
  },
}
</script>

<style lang="scss" scoped>
.s-container {
  padding: 24px 16px;
}

h2 {
  font-size: 20px;
  font-weight: bold;
  color: #207868;
  margin-bottom: 12px;
}

p {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 16px;
}

.institution-list {
  margin-bottom: 16px;
}

.institution-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 12px;
  cursor: pointer;

  &--selected {
    background-color: #207868;
    color: white;
    border-color: #207868;

    .institution-card__memo {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  &__name {
    font-weight: bold;
  }

  &__memo {
    color: #888;
    font-size: 0.875rem;
    margin-top: 4px;
  }
}

.notice-text {
  font-size: 13px;
  color: #888;
  line-height: 1.6;
  margin-bottom: 24px;
}

.footer-nav {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
}
</style>
